<template>
  <div v-if="show" class="content">
    <div class="absolute bottom-10 left-1 md:left-2 w-10 h-10 rounded-md block-bg"></div>
    <div class="absolute bottom-6 -left-5 md:-left-4 w-10 h-10 rounded-md block-bg"></div>
    <div v-if="content.totalScoreVisible" class="tag">
      <span class="mr-2">总分</span>
      <span>{{ content.totalValue }}</span>
    </div>
    <div class="flex items-center w-full h-full">
      <div class="flex-1 w-full h-full flex flex-col items-center justify-center text-white pl-4">
        <span class="text-xl sm:text-2xl mb-2">最终得分</span>
        <span class="text-3xl sm:text-4xl">{{ content.score }}</span>
      </div>
      <div class="flex-1 h-4/5 ml-6 mt-1">
        <img src="./assets/bg-icon.svg" class="h-full" alt="最终得分" />
      </div>
    </div>
    <div class="absolute bottom-16 -right-1 w-10 h-10 rounded-md block-bg"></div>
    <div class="absolute bottom-12 right-4 w-8 h-8 rounded-md block-bg"></div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Grade extends Vue {
  @Prop({ type: Object }) content!: Content & {
    score: number;
    totalValue: number;
    totalScoreVisible: boolean;
  };
  show: Boolean = false;
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 0);
  }
}
</script>
<style scoped>
.content {
  @apply relative w-full sm:w-120 h-32 mb-8 md:ml-12 rounded-motif;
  max-width: 30rem;
  background: linear-gradient(89.64deg, #667fff -3.37%, #798fff 102.76%);
  background-size: contain;
  animation: boingInUp 1.5s;
}

@-webkit-keyframes boingInUp {
  0% {
    transform: perspective(800px) rotateX(-50deg);
    transform-origin: 50% 0%;
    opacity: 0;
  }
  25% {
    transform: perspective(800px) rotateX(50deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  60% {
    transform: perspective(800px) rotateX(-25deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  70% {
    transform: perspective(800px) rotateX(13deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  80% {
    transform: perspective(800px) rotateX(-6deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  90% {
    transform: perspective(800px) rotateX(3deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  100% {
    transform: perspective(800px) rotateX(0deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
}

.tag {
  @apply absolute flex items-center justify-center h-6 top-2 left-0 bg-green-300 text-white px-2;
  border-radius: 0px 12px 12px 0px;
}

.block-bg {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
